import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/writer.css";

const Writer = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "writer");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Writer | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="writer" />
				<div className="content-wrapper">
					<div className="writer-logo-container">
						<div className="writer-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="writer-container">
						<div className="writer-main">
							<div className="writer-right-side">

								{INFO.writer.map((writer, index) => (
									<div className="writer-card" key={index}>
										<div className="title writer-title">{writer.title}</div>
										<div className="subtitle writer-subtitle">{writer.description}</div>
										{writer.evaluation && (
										  <div className="writer-evaluation">
										    <h4 className="writer-evaluation-title">Black List Evaluation</h4>
										    <p>{writer.evaluation}</p>
										  </div>
										)}
									</div>
								))}



							</div>

							<div className="writer-left-side">
								<div className="writer-image-container">
									<div className="writer-image-wrapper">
										<img
											src="writer.png"
											alt="writer"
											className="writer-image"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Writer;
